import { GlButton, GlLoadingIcon, GlOutsideDirective as Outside, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { Mousetrap } from '~/lib/mousetrap';
import { keysFor, SIDEBAR_CLOSE_WIDGET } from '~/behaviors/shortcuts/keybindings';
export default {
    name: 'WorkItemSidebarWidget',
    components: {
        GlButton,
        GlLoadingIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        Outside
    },
    props: {
        canUpdate: {
            type: Boolean,
            required: false,
            default: false
        },
        isEditing: {
            type: Boolean,
            required: false,
            default: false
        },
        isUpdating: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltipText: {
            type: String,
            required: false,
            default: undefined
        }
    },
    emits: [
        'start-editing',
        'stop-editing'
    ],
    data () {
        return {
            editing: false
        };
    },
    watch: {
        isEditing (isEditing) {
            this.editing = isEditing;
        }
    },
    mounted () {
        Mousetrap.bind(keysFor(SIDEBAR_CLOSE_WIDGET), this.stopEditing);
    },
    beforeDestroy () {
        Mousetrap.unbind(keysFor(SIDEBAR_CLOSE_WIDGET));
    },
    methods: {
        startEditing () {
            this.editing = true;
            this.$emit('start-editing');
        },
        stopEditing ({ target } = {}) {
            // This prevents the v-outside directive from treating a
            // click on the datepicker dropdown as an outside click
            if (target?.classList.contains('pika-select')) {
                return;
            }
            this.editing = false;
            this.$emit('stop-editing');
        }
    }
};
